// Main javascript entry point
// Should handle bootstrapping/starting application

'use strict';

import $ from 'jquery';
import 'jquery-match-height';
import objectFitImages from 'object-fit-images';
import lity from 'lity';

import SelectClone from '../_modules/select-clone/select-clone';
import BackToTop from '../_modules/atoms/back-to-top/back-to-top';
import Form from '../_modules/form/form';
// import Modal from '../_modules/molecules/modal/modal';

import TilesModule from '../_modules/organisms/tiles-module/tiles-module';
import SiteHeader from '../_modules/organisms/site-header/site-header';
import Accordion from '../_modules/organisms/accordion/accordion';
import GalleryWidget from '../_modules/organisms/gallery-widget/gallery-widget';
import MasonryGallery from '../_modules/organisms/masonry-gallery/masonry-gallery';
import Rte from '../_modules/organisms/rte/rte';
import ListingResults from '../_modules/organisms/listing-results/listing-results';



$(() => {
    if($("img[data-imgfallback]").length){
        $("img[data-imgfallback]").map((_,ele)=>{
            const fallbackImg = $(ele).data("imgfallback")
            const currImg = $(ele).attr("src")
            const imageTemp = new Image()
            imageTemp.onerror = ()=>{
                $(ele).attr("src", fallbackImg);
            }
            imageTemp.src = currImg
        })
    }

    const nestedClickControl = (ele)=>{
        $(ele).on('click',function(e){
            e.preventDefault()
            if($('a',$(ele)).length == 1){
                let $target = $('a',$(ele));
                if($target.data('lity') !==undefined){
                    lity($target.attr('href'))
                }else{
                    $target[0].click()
                }
            }
        })
        $('a', $(ele)).on('click',function(e){
            e.stopPropagation()
        })
    }
    $('.tile-module__tile').map((_,ele)=>{
        nestedClickControl(ele)
    })
    $('.tile-item').map((_,ele)=>{
        $("#submit-search",$(ele)).on('click',(e)=>{
            e.stopPropagation()
        })
        nestedClickControl(ele)
    })

    $('.nav__global-dropdown').on('click', function(e){
        e.stopPropagation();
    });

    //Polyfill for object-fit
    objectFitImages();

    new SiteHeader();
    new SelectClone();

    if($('.listing-results__search').length) {
        new ListingResults($('.listing-results__search'));
    }

    if ($('button.back-to-top').length) {
        $('button.back-to-top').map((i, ele) => {
            const backtotop = new BackToTop($(ele));
            backtotop.init();
        });
    }

    if ($('[data-module="tilesModule"]').length) {
        new TilesModule();
    }

    if ($('.accordion-list').length) {
        $('.accordion').map((i,ele) => {
            new Accordion($(ele));
        });
    }

    if ($('form').length) {
        new Form();
    }

    // if ($('.modal').length) {
    //     new Modal();
    // }

    if($('.rte').length) {
        $('.rte').map((i,ele) => {
            new Rte($(ele));
        });
    }

    // Bind hover class to CTAs
    $('.module__cta').each(function () {
        $(this).addClass('module__cta-hover');
    });

    // Go to link on tile click
    // $('.tile-item').map((i, ele) => {
    //     if(!$(ele).hasClass('tile-item--searchbar')){
    //         $(ele).on('click', (e) => {
    //             const $this = $(this);
    
    //             if($this.find('a').attr('target') === '_blank') {
    //                 window.open($this.find('a').attr('href'), '_blank');
    //             }
    //             else {
    //                 window.location.href = $this.find('a').attr('href');
    //             }
    //         });
    //     }
    // });

    if ($('.image-gallery').length) {
        $('.image-gallery').map((i, ele) => {
            if ($(ele).hasClass('image-gallery__full'))
                new GalleryWidget($(ele), true);
            else
                new GalleryWidget($(ele), false);
        });
    }

    if ($('.masonry-gallery').length) {
        $('.masonry-gallery').map((i, ele) => {
            new MasonryGallery($(ele));
        });
    }

    /**
     * Anchor links transition
     */

    if(window.location.hash) {
        scrollToHash(window.location.hash);
    }

    $('a.anchor').on('click', function (e) {
        e.preventDefault();

        const targetID = $(this).attr('href');

        scrollToHash(targetID);
    });
	$('a').click(function(e) {    
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - 200
        }, 500);
    });

    function scrollToHash(target) {
        if ($('.accordion-list').length) {
            $('.accordion').map((i, ele) => {
                if ($(ele).find(target).length || $(ele).find(`[name=${target.slice(1)}]`).length) {
                    if(!$(ele).hasClass('open')){
                        $('> a', $(ele)).parent().toggleClass('open');
                        $('> a', $(ele)).parent().find('.accordion__content').slideToggle();
                    }
                }
            });
        }

        // const navOffset = ($('.relative-header').length) ? 196 : 135,
        const paddingWithHeader = $('.site-header').height() + 30,
            paddingWithRelativeHeader = $('.relative-header').height() + paddingWithHeader;

        const navOffset = ($('.relative-header').length) ? paddingWithRelativeHeader : paddingWithHeader,
            $target = $(target).length ? $(target) : $(`[name=${target.slice(1)}]`);

        $('html, body').stop(true, true).animate({
            scrollTop: $target.offset().top - navOffset
        }, 500);
    }

    // custom file input
    if($('form[action^="/formbuilder"]').length){
        setInterval(() => {
            $('form[action^="/formbuilder"] input[type=file]').map((i, ele) => {
                if(!$(ele).hasClass('custom-change-event-bound')) {
                    $(ele).on('change', (e) => {
                        if(!$(ele).is('[multiple]')) {
                            $(e.currentTarget).parent().find('.file-name').text($(e.currentTarget).val().replace(/C:\\fakepath\\/i, ''));
                        }
                        else {
                            let labels = [];

                            for(let key in $(e.currentTarget)[0].files) {
                                if(!isNaN(key)) {
                                    labels.push(`${$(e.currentTarget)[0].files[key].name}`);
                                }
                            }

                            $(e.currentTarget).parent().find('.file-name').text(`${labels.join(', ')}`);
                        }
                    });
                    $(ele).addClass('custom-change-event-bound');
                }
            });
        }, 500);
    }
    else {
        if($('input[type=file]').length) {
            $('input[type=file]').map((i, ele) => {
                if(!$(ele).hasClass('custom-change-event-bound')) {
                    $(ele).on('change', (e) => {
                        if(!$(ele).is('[multiple]')) {
                            $(e.currentTarget).parent().find('.file-name').text($(e.currentTarget).val().replace(/C:\\fakepath\\/i, ''));
                        }
                        else {
                            let labels = [];

                            for(let key in $(e.currentTarget)[0].files) {
                                if(!isNaN(key)) {
                                    labels.push(`${$(e.currentTarget)[0].files[key].name}`);
                                }
                            }

                            $(e.currentTarget).parent().find('.file-name').text(`${labels.join(', ')}`);
                        }
                    });
                    $(ele).addClass('custom-change-event-bound');
                }
            });
        }
    }

    $('.match-height').matchHeight();
});